/**
 * MEDIA_ADAPTER_EVENT_TYPE
 * ------------------------
 *
 * Adapter-level local media event vocabulary.
 *
 * These are runtime/media facts observed by the adapter layer.
 * They are not reducer/controller events directly.
 */
export const MEDIA_ADAPTER_EVENT_TYPE = {
    DEVICES_CHANGED: "DEVICES_CHANGED",
    SPEAKING_CHANGED: "SPEAKING_CHANGED",
};
